export default "__VITE_ASSET__BE4dkZ6z__"